angular.module("events_types")

    .controller("EventsTypesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate','$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_TYPES_WRITE");

        $rootScope.title = $filter('translate')('events_types.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('events_types.title') }
        ];

            $scope.gridOptions = {
            pdfTitle: $filter('translate')('events_types.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,             
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('events_types.name'), enableFiltering: true, enableHiding: false },
              {
               name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">'+
               '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
               '</div>', width: 80, enableFiltering: false, enableHiding: false
                },
                { name: 'color', displayName: $filter('translate')('general.color'), enableFiltering: false, cellTemplate: gridService.colorTemplate("color"), maxWidth: 50 },
                {
                    name: 'is_parent', displayName: $filter('translate')('event_type.is_parent'),  width: 100, enableFiltering: true, enableHiding: false, visible: true,
                    cellTemplate: `<div class="ui-grid-cell-contents ng-binding ng-scope" syle="text-aling: center"><span ng-if="row.entity.is_parent" style="color:#1ab394" <i class="fas fa-check"></i></span></div>`,
                },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('events_types.button_edit'), action: 'ui-sref="events_types.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('events_types.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {             
                return Restangular.all('EventsTypes').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("events_types.edit", { id: rowEntity.id });
        }


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('events_types.button_delete'),
                message: $filter('translate')('events_types.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('EventsTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('events_types.deleted_success'));
                        $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;